<template>
  <div
    v-if="getParvandehCount() > 1"
    class="parvandeh"
    v-click-outside="closePopup"
  >
    <Loading :loading="loading" :minimized="minimized">
      <template #default>
        <div
          class="parvandeh__content"
          :class="{ parvandeh__minimized: minimized }"
          @click="showParvandehList()"
        >
          <div class="parvandeh__right-box">
            <div class="parvandeh__icon-box">
              <mdicon name="folder-outline" size="16" class="d-flex" />
            </div>
            <div v-show="!minimized" class="parvandeh__name">
              {{ currentParvandehCaption }}
            </div>
          </div>
          <div v-show="!minimized" class="parvandeh__left-box">
            <mdicon name="unfold-more-horizontal" size="16" />
          </div>
        </div>
      </template>
    </Loading>
    <div class="desktop-popup">
      <slide-y-up-transition>
        <div class="parvandeh__cover" v-if="show">
          <div class="parvandeh__modal">
            <div class="parvandeh__label">
              {{ $lang.your_parvandeh_list }}
            </div>
            <div v-if="loading" class="parvandeh__items">
              <div
                v-for="(item, index) in [1, 2, 3]"
                :key="index"
                class="parvandeh__loading-item"
              >
                <div class="w-100">
                  <div class="parvandeh__title margin-bottom-12">
                    <b-skeleton width="50%"></b-skeleton>
                  </div>
                  <div class="parvandeh__description">
                    <b-skeleton width="70%"></b-skeleton>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="parvandeh__items">
              <div
                v-for="(item, index) in items"
                :key="index"
                class="parvandeh__item"
                :class="{
                  'parvandeh--active': item.active,
                }"
                @click="changeRole(item)"
              >
                <div>
                  <div class="parvandeh__title">
                    {{ item.title }}
                  </div>
                  <div class="parvandeh__description">
                    {{ item.description }}
                  </div>
                </div>
                <div v-if="item.active">
                  <mdicon name="check" size="24" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </slide-y-up-transition>
    </div>
    <MobilePopup :show="show" @setShow="setShow">
      <template>
        <div class="parvandeh__label">
          {{ $lang.your_parvandeh_list }}
        </div>
        <div v-if="loading" class="parvandeh__items">
          <div
            v-for="(item, index) in [1, 2, 3]"
            :key="index"
            class="parvandeh__loading-item"
          >
            <div class="w-100">
              <div class="parvandeh__title margin-bottom-12">
                <b-skeleton width="50%"></b-skeleton>
              </div>
              <div class="parvandeh__description">
                <b-skeleton width="70%"></b-skeleton>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="parvandeh__items">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="parvandeh__item"
            :class="{
              'parvandeh--active': item.active,
            }"
            @click="changeRole(item)"
          >
            <div>
              <div class="parvandeh__title">
                {{ item.title }}
              </div>
              <div class="parvandeh__description">
                {{ item.description }}
              </div>
            </div>
            <div v-if="item.active">
              <mdicon name="check" size="24" />
            </div>
          </div>
        </div>
      </template>
    </MobilePopup>
  </div>
</template>

<script>
import Loading from "./Loading.vue";
import MobilePopup from "../modal/MobilePopup.vue";
import { pathOr } from "ramda";
import {
  checkScreenDevice,
  generateCurrentRoute,
  getActiveParvandeh,
  getParvandehCount,
  goToRoute,
} from "@/shared/utils";
import { getMyParvandeh, parvandehChangeRole } from "@/services";

export default {
  components: { Loading, MobilePopup },
  props: {
    minimized: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      loading: false,
      items: [],
      currentParvandehCaption: "",
    };
  },
  watch: {
    show: {
      immediate: true,
      handler(value) {
        value && this.getMyParvandehList();
      },
    },
  },
  created() {
    this.generateCurrentParvandehCaption();
  },
  methods: {
    pathOr,
    getActiveParvandeh,
    getParvandehCount,
    goToDashboard() {
      const currentRouteName = generateCurrentRoute();
      if (currentRouteName !== "dashboard") {
        goToRoute("dashboard", {}, {}, false);
      }
    },
    showParvandehList() {
      // show parvandeh list just when parvandeh list bigger than 1
      if (getParvandehCount() <= 1) return;
      this.setShow(!this.show);
      this.$emit("close");
    },
    generateCurrentParvandehCaption() {
      const parvandehNumber = this.getActiveParvandeh(["parvandeh_number"]);
      this.currentParvandehCaption = `${this.$lang.parvandeh} - ${parvandehNumber}`;
    },
    generateItems() {
      this.items = this.items.map((item) => {
        const licenseCaption = pathOr("", ["license", "caption"], item);
        const parvandehNumber = pathOr("", ["parvandeh_number"], item);
        const term = pathOr("", ["term", "caption"], item);
        const roles = pathOr([], ["roles"], item);
        const title = `${this.$lang.parvandeh} - ${parvandehNumber}`;
        const description = licenseCaption
          ? term
          : `${term} - ${roles.join(" - ")}`;

        return {
          ...item,
          title,
          description,
          active:
            parvandehNumber === this.getActiveParvandeh(["parvandeh_number"]),
        };
      });
    },
    setShow(value) {
      this.show = value;
    },
    closePopup() {
      if (!checkScreenDevice(["desktop"])) return;
      this.setShow(false);
    },
    async getMyParvandehList() {
      if (this.loading || this.items.length) return;
      try {
        this.loading = true;
        const response = await getMyParvandeh();
        const { items } = response;
        this.items = items;
        this.generateItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    async changeRole(item) {
      const { active, ...parvandeh } = item;
      if (active) return;

      try {
        this.loading = true;
        const response = await parvandehChangeRole(parvandeh);
        const { message } = response;
        this.$notify.success(message);
        this.generateItems();
        this.generateCurrentParvandehCaption();
        this.setShow(false);
        goToRoute("dashboard", {}, {}, false);
        this.goToDashboard();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
